import moment from 'moment';
import 'moment/locale/hu';
import { enableES5 } from 'immer';
import 'unorm';
import {
  SELECT_CINEMA, SELECT_WEEK,
  SELECT_DATE, FILM_DETAILS_SUCCEDED,
  OPEN_MODAL, CLOSE_MODAL,
  GET_CURRENT_TIME, SET_BRAND,
  WEEKS_AND_CINEMAS_SUCCEDED,
  FILM_DETAILS_REQUESTED,
  WEEKS_AND_CINEMAS_REQUESTED,
} from 'consts/actionTypes';
import initialState from './initialState';

enableES5();

const appReducer = (state = initialState, action) => {
  moment.locale('hu');
  switch (action.type) {
    case SET_BRAND: {
      const { brand } = action.payload;
      return {
        ...state,
        brand: brand === null ? 0 : +brand,
      };
    }

    case SELECT_CINEMA: {
      const { cinema } = action.payload;
      const actualWeek = state.weeksDetails.find(weekDetail => `${weekDetail.week}` === `${state.selectedWeek}`);
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === state.selectedDate);
      const actualMovies = actualDate.movies.length > 0 ? actualDate.movies[0].schedule.map(schedule => ({
        ...schedule,
        cinemas: schedule.cinemas.filter(cinemaId => cinemaId.id === cinema),
      })) : [];
      const filteredMovies = actualMovies[0] ? actualMovies : [];
      return {
        ...state,
        selectedCinema: +cinema,
        filteredMovies,
      };
    }

    case FILM_DETAILS_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }

    case SELECT_WEEK: {
      const { week } = action.payload;
      const actualWeek = state.weeksDetails.find(weekDetail => +weekDetail.week === +week);
      const actualDates = actualWeek.schedule.map(dates => dates.date);
      const findDate = actualDates.find(date => date === moment().format('YYYYMMDD'));
      const selectedDate = findDate || actualDates[0];
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === selectedDate);
      const actualMovies = actualDate.movies.length > 0 ? actualDate.movies[0].schedule.map(schedule => ({
        ...schedule,
        cinemas: schedule.cinemas.filter(cinemaId => cinemaId.id === state.selectedCinema),
      })) : [];
      const filteredMovies = actualMovies[0] ? actualMovies : [];
      return {
        ...state,
        selectedWeek: week,
        selectedDate,
        filteredMovies,
        dates: actualDates.map(date => ({
          dateId: date,
          date: moment(date).format('MMM. DD'),
          day: date === moment().format('YYYYMMDD') ? 'Ma' : moment(date).format('dddd'),
          disabledDate: date !== moment().format('YYYYMMDD') && moment(date).isBefore(moment()),
        })),
      };
    }

    case SELECT_DATE: {
      const { date } = action.payload;
      const actualWeek = state.weeksDetails.find(weekDetail => `${weekDetail.week}` === `${state.selectedWeek}`);
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === date);
      const actualMovies = actualDate.movies.length > 0 ? actualDate.movies[0].schedule.map(schedule => ({
        ...schedule,
        cinemas: schedule.cinemas.filter(cinemaId => cinemaId.id === state.selectedCinema),
      })) : [];
      const filteredMovies = actualMovies[0] ? actualMovies : [];
      return {
        ...state,
        selectedDate: date,
        filteredMovies,
      };
    }

    case FILM_DETAILS_SUCCEDED: {
      const { schedule, weeks, cinemas, movie } = action.payload;
      const { movieId } = action;
      const appCinemas = Object.keys(cinemas).map(id => ({
        ...cinemas[id],
        id: +id,
        weight: +cinemas[id].weight,
      }));
      const sortedCinemas = appCinemas.sort((a, b) => a.weight - b.weight);
      const tempCinema = cinemas;
      const selectedWeek = state.selectedWeek || +weeks[0];
      const findDate = Object.keys(schedule[selectedWeek]).find(date => date === moment().format('YYYYMMDD'));
      const notEmptyDate = Object.keys(schedule[selectedWeek]).find(date => schedule[selectedWeek][date].length === undefined); //eslint-disable-line
      const selectedDate = findDate || notEmptyDate;
      const selectedCinema = sortedCinemas[0].id;
      const playTimes = Object.keys(schedule[selectedWeek][selectedDate][movieId]);
      const actualMovies = playTimes.length > 0 ? playTimes.map(playtime => ({
        playtime,
        cinemas: Object.keys(schedule[selectedWeek][selectedDate][movieId][playtime]).map(key => ({
          ...tempCinema[schedule[selectedWeek][selectedDate][movieId][playtime][key].cinema],
          ...schedule[selectedWeek][selectedDate][movieId][playtime][key],
        })).filter(cinema => +cinema.cinema === +selectedCinema),
      })) : [];
      const filteredMovies = actualMovies[0] ? actualMovies : [];
      return {
        ...state,
        loading: false,
        movie,
        filteredMovies,
        cinemas: sortedCinemas,
        weeks: weeks.map(week => +week),
        dates: Object.keys(schedule[selectedWeek]).map(date => ({
          dateId: date,
          date: moment(date).format('MMM. DD'),
          day: date === moment().format('YYYYMMDD') ? 'Ma' : moment(date).format('dddd'),
          disabledDate: date !== moment().format('YYYYMMDD') && moment(date).isBefore(moment()),
        })),
        selectedWeek,
        selectedDate,
        selectedCinema,
        weeksDetails: [
          ...Object.keys(schedule).map(week => ({
            week,
            schedule: Object.keys(schedule[week]).map(date => ({
              date,
              movies: Object.keys(schedule[week][date]).map(currentMovie => ({
                movieId: currentMovie,
                schedule: Object.keys(schedule[week][date][currentMovie]).map(playtime => ({
                  playtime,
                  cinemas: Object.keys(schedule[week][date][currentMovie][playtime])
                    .map(key => ({
                      ...Object.keys(cinemas).map(id => ({
                        ...cinemas[id],
                        id: +id,
                      })).find(cin => cin.id === schedule[week][date][currentMovie][playtime][key].cinema),
                      ...schedule[week][date][currentMovie][playtime][key],
                    })),
                })),
              })),
            })),
          })),
        ],
      };
    }

    case WEEKS_AND_CINEMAS_SUCCEDED: {
      const { cinemas } = action.payload;
      const appCinemas = Object.keys(cinemas).map(id => ({
        ...cinemas[id],
        id: +id,
      }));
      const brandCinema = appCinemas.find(appCinema => appCinema.id === +state.brand);
      return {
        ...state,
        loading: false,
        brandClass: brandCinema ? `react-${brandCinema.logo}` : 'react-artmozi',
      };
    }

    case WEEKS_AND_CINEMAS_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }

    case OPEN_MODAL: {
      const { activeModal } = state;
      const { modalData } = action.payload;
      const newState = (activeModal.title === modalData.title && activeModal.playtime === modalData.playtime)
        ? {
          title: null,
          playtime: null,
        }
        : {
          title: modalData.title,
          playtime: modalData.playtime,
        };

      return {
        ...state,
        activeModal: {
          ...newState,
        },
      };
    }

    case GET_CURRENT_TIME: {
      return {
        ...state,
        currentTime: {
          ...state.currentTime,
          dateNowIndex: state.timeList.findIndex(time => time.includes(new Date().getHours())),
          hours: new Date().getHours(),
          minutes: new Date().getMinutes(),
        },
      };
    }

    case CLOSE_MODAL: {
      return {
        ...state,
        activeModal: {
          title: null,
          index: null,
        },
      };
    }

    default:
      return state;
  }
};

export default appReducer;
